<template>
  <el-card shadow="never">
    <table-view
      :table-model="tableModel1"
      :table-data="tableData1"
      :showPage="false"
    />
    <table-view
      :table-model="tableModel2"
      :table-data="tableData2"
      :showPage="false"
    />
    <div v-for="(value, name) in settingMap" :key="name">
      <h2 style="padding-left: 24px">{{ name }}</h2>
      <table-view
        :table-model="tableModel3"
        :table-data="value"
        :showPage="false"
      />
    </div>
  </el-card>
</template>

<script>
import { getCardModelDetail } from './api'

export default {
  data() {
    return {
      tableModel1: [
        {
          label: 'Scorecard Name',
          prop: 'scoreCardName',
        },
      ],
      tableData1: [],
      tableModel2: [
        {
          label: 'Criteria Name',
          prop: 'criteriaName',
        },
        {
          label: 'Weight',
          prop: 'weight',
        },
      ],
      tableData2: [],
      tableModel3: [
        {
          label: 'Criteria Lower Range',
          prop: 'criteriaLowerRange',
        },
        {
          label: 'Criteria Upper Range',
          prop: 'criteriaUpperRange',
        },
        {
          label: 'Criteria Value',
          prop: 'criteriaValue',
        },
      ],
      settingMap: {},
    }
  },
  mounted() {
    this._getCardModelDetail()
  },
  methods: {
    async _getCardModelDetail() {
      try {
        const {
          scoreCardName = '',
          settingMap,
          creditScoreCardCriteriaVOList,
        } = await getCardModelDetail(this.$route.params.cardId)
        this.tableData1.push({ scoreCardName: scoreCardName })
        this.tableData2 = creditScoreCardCriteriaVOList
        this.tableData2.push({ criteriaName: 'total', weight: '100%' })
        this.settingMap = settingMap
        settingMap['Capital Stock'].map(item => {
          item.criteriaLowerRange === '&gt; 401%' ||
          item.criteriaLowerRange === '&gt;401%'
            ? (item.criteriaLowerRange = '> 401%')
            : item.criteriaLowerRange
        })
        settingMap['Commercial Registry / Company Name Change'].map(item => {
          item.criteriaLowerRange ===
            'company name change &gt; 5 years Or null' ||
          item.criteriaLowerRange === 'company name change&gt; 5 years Or null'
            ? (item.criteriaLowerRange =
                'company name change > 5 years Or null')
            : item.criteriaLowerRange
        })
      } catch (e) {
        console.log(e)
      }
    },
  },
}
</script>

<style scoped></style>
